import { IReportErrorBodyArgs } from '@reolink-cloud/interface';
import { getSessionIdFromStore } from '@/utils/sessionId';

export const uploadErrorLog = async ( args: IReportErrorBodyArgs ): Promise<void> => {

    const sessionId = await getSessionIdFromStore();
    
    const headers: Record<string, string> = {
        'Content-Type': 'application/json'
    };

    // 在 ctx 中也添加 sessionId
    const body: IReportErrorBodyArgs = {
        ...args,
        ctx: {
            ...( args.ctx ?? {}),
            sessionId: sessionId ?? undefined,
            userAgent: navigator.userAgent
        }
    };

    await fetch( `${import.meta.env.VITE_API_HOST}/v2/front-end/errors`, {
        method: 'POST',
        headers,
        body: JSON.stringify( body )
    });

};
